import { PayloadAction } from "@reduxjs/toolkit";
import { PillarDataType, PillarState } from "@/components/PagePiller/redux/types";

const PillarReducer = {
  setPillarData: (state: PillarState, action: PayloadAction<PillarDataType>) => {
    state.pillarData = action.payload;
  },
};

export default PillarReducer;
